module.exports = __webpack_public_path__ + "img/home_inet.dbc7c47b.png";